import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftBox: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gift-box, present"><path d="M21.25 4.75H2.75V9.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M3.75 9.25V19.25H20.25V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGiftBox;
